import enquireJs from "enquire.js";
export default {
  // 监测浏览器宽度来判断是不是移动端
  enquireScreen: function(call) {
    const handler = {
      match: function() {
        call && call(true);
      },
      unmatch: function() {
        call && call(false);
      },
    };
    enquireJs.register("only screen and (max-width: 760px)", handler);
  },
};
